import { Card, Datepicker, SofturaTable, ModalPopup, Label, EventHandler } from "client/CommonComponents";
import moment from "moment";
import excel from '../../../assets/images/Excel.svg'
import { useRef } from "react";
import createAudit from '../../../assets/images/Create Audit.svg'
import CreateNewAudit from './CreateNewAudit'
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import { commonExportExcel, handleClearDateFilter, handleDateFilter } from "utils";
import permissions, { ACCESS_DENIED, isAuthorized } from "client/utils/Permissions";

const AuditDates = (props: any) => {
  const { onChangeAuditYear,
    yearsDropDown,
    onDateChange,
    auditList,
    auditDetails,
    maxDateRange,
    minDateRange,
    error,
    isEditClick,
    deletePopup,
    setDeletePopup,
    deleteAuditDate,
    isNotEditable,
    gridData,
    disableAuditYear,
    hideDialogComplete,
    popupContent
  } = props

  const AuditStartDateRef = useRef(null);
  const AuditEndDateRef = useRef(null);
  const AuditReadinessStartDateRef = useRef(null);
  const AuditReadinessEndDateRef = useRef(null);
  const AuditTrainingStartDateRef = useRef(null);
  const AuditTrainingEndDateRef = useRef(null);

  const AuditDateFilterCell = (props: any) => {
    const { search, dateRef } = props;
    return (
      <div className="date-filter-wrapper">
        <Datepicker
          placeholder="Select"
          value={dateRef.current}
          onChangeDate={(date: any) =>
            handleDateFilter(date, search, dateRef)
          }
         data-attribute="AuditDates_Default_Datepicker" />
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
          onClick={() => handleClearDateFilter(search, dateRef)}
        ></i>
      </div>
    );
  };



  const auditDateColumn = [
    {
      key: "Action",
      title: "Action",
      width: 60,
      Cell: (row: any) => props?.CustomCell(row?.rowData),
      style: { textAlign: 'center' },
      id: 'action-column'
    },
    {
      key: "fy",
      title: "Year",
      width: 150,
    },
    {
      key: "cycleStartDate",
      title: "Audit Start Date",
      width: 150,

      FilterCell: (AuditStartDateProps: any) => {
        return <AuditDateFilterCell
          {...AuditStartDateProps}
          dataItem={auditList}
          dateRef={AuditStartDateRef}
        />;
      },
    },
    {
      key: "cycleEndDate",
      title: "Audit End Date",
      width: 150,
      FilterCell: (AuditStartDateProps: any) => {
        return <AuditDateFilterCell
          {...AuditStartDateProps}
          dataItem={auditList}
          dateRef={AuditEndDateRef}
        />;
      },
    },
    {
      key: "auditReadinessStartDate",
      title: "Audit Readiness Start Date",
      width: 150,
      FilterCell: (AuditStartDateProps: any) => {
        return <AuditDateFilterCell
          {...AuditStartDateProps}
          dataItem={auditList}
          dateRef={AuditReadinessStartDateRef}
        />;
      },
    },
    {
      key: "auditReadinessEndDate",
      title: "Audit Readiness End Date",
      width: 150,
      FilterCell: (AuditStartDateProps: any) => {
        return <AuditDateFilterCell
          {...AuditStartDateProps}
          dataItem={auditList}
          dateRef={AuditReadinessEndDateRef}
        />;
      },
    },
    {
      key: "auditTrainingStartDate",
      title: "Audit Training Start Date",
      width: 150,
      FilterCell: (AuditStartDateProps: any) => {
        return <AuditDateFilterCell
          {...AuditStartDateProps}
          dataItem={auditList}
          dateRef={AuditTrainingStartDateRef}
        />;
      },
    },
    {
      key: "auditTrainingEndDate",
      title: "Audit Training End Date",
      width: 150,
      FilterCell: (AuditStartDateProps: any) => {
        return <AuditDateFilterCell
          {...AuditStartDateProps}
          dataItem={auditList}
          dateRef={AuditTrainingEndDateRef}
        />;
      },
    }
  ]

  const formatDate = (date: any) => {
    const formatDate = moment(date).format('MM/DD/YYYY')
    return formatDate ?? '';
  }

  const onExportExcel = (_e: any) => {
    if (auditList) {
      let dataTable: any[] = [];
      let columnHeaders: any[] = [];
      auditList.forEach((item: any) => {
        let excelData: any = {};
        auditDateColumn.forEach((colDef: any) => {
          if (colDef?.title != 'Action') {
            const colName = colDef?.title;
            const key = colDef?.key;
            let colValue = ''
            if (key.includes("Date") && item[key] != null) {
              colValue = formatDate(item[key]);
            } else {
              colValue = item[key] ?? "";
            } 
            excelData[colName] = colValue;
            if (columnHeaders.length != Object.keys(auditList).length) {
              columnHeaders.push(colName);
            }
          }
        });
        dataTable.push(excelData);
      });
      commonExportExcel(dataTable, columnHeaders, 'AuditDates', 'AuditDates.xlsx')
    }
  }

  return (
    <div className='assessment-question CustomerMyOrder mt-1'>
      <div className='breadcrumb-toolbar'>
        <button
          className='create-new-order-btn mb-3 me-2 pointer'
          title={isAuthorized(permissions.CreateEditAudit) ? "Create New Audit" : ACCESS_DENIED}
          disabled={!(isAuthorized(permissions.CreateEditAudit) || isAuthorized(permissions.ViewAudit))}
          onClick={props.CreateNewAuditClick}
         data-attribute="AuditDates_Default_Button">
          <img src={createAudit} alt='btn-icon' /><span>Create New Audit</span>
        </button>
      </div>
      <Card data-attribute="AuditDates_Default_Card">
        <div className='create-new-order-container'>
          <div className='grid-block pt-2'>
            <div className='mb-1 top-section'>
              <div className='clearfix mt-sm-2'>
                <div className='pull-left searchblock'>
                  <p className='assesst-question-head'>AUDIT DATES</p>
                </div>
                <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-0'>
                  <div className={`excel-section pointer ${isAuthorized(permissions.CreateEditAudit) ? "" : "disable-export-excel"}`}>
                                        <EventHandler onEvent={onExportExcel} data-attribute="AuditDates_Default_EventHandler">
                                          <img src={excel} alt='excel' />
                                        </EventHandler>              
                  </div>
                </div>
              </div>
            </div>
            <div className={`${auditList?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
              <SofturaTable
                data={gridData ?? []}
                columns={auditDateColumn}
                sort={true}
                defaultPageSize={10}
                pageSizes={[10, 20, 50]}
                globalSearch={false}
                filter={true}
               data-attribute="AuditDates_Default_Grid" />
            </div>
          </div>
        </div>
        {props?.submitPopupcontent.isDialogVisible &&
          <CompleteConfirmationPopup
            hideDialog={!props?.submitPopupcontent.isDialogVisible}
            onDismiss={() => props?.submitPopupcontent.popupOutlinebtnOnclick()}
            Popupcontent={props?.submitPopupcontent}
            popupOutlinebtnOnclick={() => props?.submitPopupcontent.popupOutlinebtnOnclick()}
            popupPrimarybtnOnclick={() => props?.submitPopupcontent.popupPrimarybtnOnclick()}
          />
        }
      </Card>
      {deletePopup && (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete Audit Date"
          ModalPopupType="small"
          FooterSecondaryBtnTxt="cancel"
          FooterPrimaryBtnTxt="Delete"
          closeModalPopup={() => setDeletePopup(false)}
          PrimaryBtnOnclick={deleteAuditDate}
          SecondryBtnOnclick={() => { setDeletePopup(false) }}
          ModalPopupName='Delete Popup'
         data-attribute="AuditDates_Default_ModalPopup">
          <Label data-attribute="AuditDates_Default_Label">Are you sure you want to delete this Auidt Date?</Label>
        </ModalPopup>
      )}
      {props?.CreateAuditPopup ?
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle={isEditClick ? "EDIT AUDIT" : "CREATE AUDIT"}
          ModalPopupType="medium"
          closeModalPopup={props?.hidePopup}
          ModalPopupName='useraccess-popup'
          FooterPrimaryBtnTxt='Submit'
          FooterSecondaryBtnTxt='Cancel'
          PrimaryBtnOnclick={props?.handleSubmitAudit}
          SecondryBtnOnclick={props?.hidePopup}
          isFooterPrimaryBtnDisable = {!isAuthorized(permissions.CreateEditAudit)}
         data-attribute="AuditDates_Default_ModalPopup_2">
          <CreateNewAudit
            yearsDropDown={yearsDropDown}
            onChangeAuditYear={onChangeAuditYear}
            onDateChange={onDateChange}
            auditDetails={auditDetails}
            maxDateRange={maxDateRange}
            minDateRange={minDateRange}
            error={error}
            isEditClick={isEditClick}
            isNotEditable={isNotEditable}
            disableAuditYear = {disableAuditYear}
          />
        </ModalPopup>
        : ""}
        <CompleteConfirmationPopup
                hideDialog={hideDialogComplete}
                onDismiss={popupContent?.popupOutlinebtnOnclick}
                Popupcontent={popupContent}
                popupOutlinebtnOnclick={popupContent?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={popupContent?.popupPrimarybtnOnclick}
            />

    </div>
  )
}

export default AuditDates;